export default {
    baseStyle: () => ({
        container: {
            position: 'relative'
        },
        link: {
            display: 'block',
            textDecoration: 'none'
        },
        absoluteFavIcon: {
            position: 'absolute',
            bottom: '4px',
            right: 0,
            minWidth: 'auto',
            width: '30px',
            height: '30px'
        },
        imageWrapper: {
            position: 'relative',
            _hover: {
                '& .main-image': {
                    display: {base: 'block', lg: 'none'}
                },
                '& .hover-image': {
                    display: 'block'
                }
            }
        },
        image: {
            bg: 'whiteSmoke'
        },
        hoverImage: {
            display: 'none'
        },
        price: {
            display: 'flex',
            gap: '6px'
        },
        rating: {},
        variations: {},
        badgeGroup: {
            position: 'absolute',
            top: '2px',
            left: '6px',
            gap: '5px'
        },
        badgeCustomStyle: {
            bg: 'white',
            paddingLeft: '4px',
            paddingRight: '4px',
            textTransform: 'none',
            fontWeight: 'normal',
            fontSize: '12px'
        },
        promoCallout: {
            display: 'inline-block',
            color: 'white',
            backgroundColor: 'fullBlack',
            px: 2
        },
        colorList: {
            display: 'flex',
            gap: '6px',
            py: '10px'
        },
        colorLink: {
            display: 'block'
        },
        colorChip: {
            width: '17px',
            height: '17px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: 'full',
            border: '1px solid',
            borderColor: 'fullBlack',
            boxSizing: 'content-box'
        },
        remainingColorsLink: {
            textDecoration: 'none',
            color: 'darkGray',
            display: 'block',
            position: 'relative',
            marginTop: '-2px'
        }
    }),
    parts: [
        'container',
        'imageWrapper',
        'image',
        'price',
        'title',
        'rating',
        'variations',
        'badgeGroup'
    ]
}
